import { render, staticRenderFns } from "./goodsAuditDetail.vue?vue&type=template&id=96a3b54e&scoped=true&"
import script from "./goodsAuditDetail.vue?vue&type=script&lang=js&"
export * from "./goodsAuditDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsAuditDetail.vue?vue&type=style&index=0&id=96a3b54e&prod&lang=scss&scoped=true&"
import style1 from "./goodsAuditDetail.vue?vue&type=style&index=1&id=96a3b54e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a3b54e",
  null
  
)

export default component.exports